// src/components/Header.js
import React, {useState} from 'react';
import icon from '../assets/icon_pixel.png';
import './Header.css'; // Import the CSS file

function Header() {
    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <header className="header">
            <div className="header-content">
                <div className="logo-container">
                    <img src={icon} alt="Wisemoji Logo" className="logo" />
                </div>
                <button className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
                    ☰
                </button>
            </div>
            <nav className={`nav ${menuOpen ? 'nav-open' : ''}`}>
                <a href="#home" className="nav-link">
                    <span  onClick={() => setMenuOpen(!menuOpen)} className="nav-text">Home</span>
                </a>
                <a href="#about" className="nav-link">
                    <span onClick={() => setMenuOpen(!menuOpen)} className="nav-text">About</span>
                </a>
                <a href="#whitepaper" className="nav-link">
                    <span  onClick={() => setMenuOpen(!menuOpen)} className="nav-text">Whitepaper</span>
                </a>
                <a href="#community" className="nav-link">
                    <span  onClick={() => setMenuOpen(!menuOpen)} className="nav-text">Community</span>
                </a>
            </nav>
        </header>
    );
}

export default Header;